// A map of places with the visitor among them (App\Livewire\Location\Map; map.js, loaded when it's first shown: a page
// may hold it hidden, the Stallion Directory's List): the visitor's dot and the line to one place move in place when the
// component's `you` and `line` change (a new reading)
Alpine.data('placesMap', (places, start) => ({
    init() {
        // fetched at once (a first tap on Map doesn't wait for it), built once there's room for it
        const loading = import('./map.js');
        const shown = new ResizeObserver(async () => {
            if (!this.$el.offsetWidth) return;
            shown.disconnect();
            const { pins } = await loading;
            const map = pins(this.$el, places, start, this.$wire.you, this.$wire.line, this.$wire.distances);
            this.$wire.$watch('you', () => map.visitor(this.$wire.you, this.$wire.line, this.$wire.distances));
        });
        shown.observe(this.$el);
    },
}));
